import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';

import { IChaluka } from "../chaluka";
import { MatanotService } from "../../matanot.service";

import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@Component({
    moduleId: module.id,
    templateUrl: './chaluka-update.component.html',
    providers: [MatanotService]
})

export class UpdateChalukatComponent implements OnInit {
    customer: IChaluka;
    today: Date = new Date();
    customerSignature: string;
    isvalidform: boolean = true;
    errorMessage: string;

    @ViewChild(SignaturePad) signaturePad: SignaturePad;

    signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
        'minWidth': 2,
        'canvasWidth': 500,
        'canvasHeight': 250,
        backgroundColor: '#ebebeb'
    };

    constructor(private activatedRoute: ActivatedRoute,
        private _matanotService: MatanotService,
        private router: Router) { }

    ngAfterViewInit() {

        // this.signaturePad is now available
        this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
        this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.customer = <IChaluka>JSON.parse(params.customer);
        });
    }

    drawComplete() {
        // will be notified of szimek/signature_pad's onEnd event
        //debugger;
        // console.log(this.signaturePad.toDataURL());
        this.customerSignature = this.signaturePad.toDataURL();
    }

    drawStart() {
        // will be notified of szimek/signature_pad's onBegin event
        console.log('begin drawing');
    }

    submit(event) {
        event.preventDefault();
    }
    ishurClicked(event) {

        event.preventDefault();

        if (this.customer.ms_zehut == 0 || this.customer.ms_zehut == null) {
            this.isvalidform = false;
            this.errorMessage = 'חלה שגיאה, בקליטת נתוני לקוח';
            return;
        }

        if(!this.customerSignature){
            this.isvalidform = false;
            this.errorMessage = 'חובה לחתום על אישור קבלת השי';
            return;
        }

        this._matanotService.saveChalukaApproved(this.customer.ms_zehut, this.customerSignature)
            .subscribe(m => {
                if (!m.status) {
                    this.isvalidform = false;
                    this.errorMessage = m.returnMessage;
                }
                else {
                    this.router.navigateByUrl('/chalukat-matanot');
                }
            },
            error => {
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                }
                else {
                    this.isvalidform = false;
                    this.errorMessage = 'חלה שגיאה, נא נסה שוב מאוחר יותר';
                }
            })
    }
}